<template>
  <nav class="nav" v-if="routeLayout.isNav">
    <button class="nav-icon" :class="{ on: isOn(/(\/main)(\?.*)?/g) }" @click="fnPage('/main?isRoot=1')">
      <span class="i-home"></span>
      <span class="ttl">{{ $t('tabBar.home') }}</span>
    </button>
    <button class="nav-icon" :class="{ on: isOn(/(\/fav)(.*)?/g) }" @click="fnPage('/fav?isRoot=1')">
      <span class="i-likes"></span>
      <span class="ttl">{{ $t('tabBar.fav') }}</span>
    </button>
    <button
      class="nav-icon"
      :class="{ on: isOn(/(\/order\/history)(.*)?/g) }"
      @click="fnPage('/order/history?isRoot=1')"
    >
      <span class="i-order"></span>
      <span class="ttl">{{ $t('tabBar.orderList') }}</span>
    </button>
    <button class="nav-icon" :class="{ on: isOn(/(\/chat)(.*)?/g) }" @click="fnPage('/chat')">
      <span class="i-chat"></span>
      <span class="ttl">{{ $t('tabBar.chat') }}</span>
      <span class="count" v-if="!!bubbleCount.totalBubbleCount">{{ clippingBadge(bubbleCount.totalBubbleCount) }}</span>
    </button>
    <button class="nav-icon" :class="{ on: isOn(/(\/my)(.*)?/g) }" @click="fnPage('/my?isRoot=1')">
      <span class="i-user"></span>
      <span class="ttl">{{ $t('tabBar.my') }}</span>
    </button>
  </nav>
</template>
<script>
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, onUpdated, ref, toRef, toRefs } from 'vue';

const layoutState = () => {
  const { getters } = useStore();
  const routeLayout = computed(() => {
    return getters['layout/getRouteLayout'];
  });
  return {
    routeLayout
  };
};

export default {
  name: 'the-nav',
  description: '하단 네비게이션',
  emits: ['height'],
  setup() {
    const $store = useStore();
    const bubbleCount = computed(() => $store.getters['chat/getBubbleCounts']);
    const clippingBadge = (count) => (count > 100 ? '99+' : count);
    const router = useRouter();
    const fnPage = (path) => {
      router.push(path);
    };
    const isOn = (page) => {
      const { fullPath } = useRoute();
      return (fullPath.match(page) ?? []).length > 0;
    };
    return { ...layoutState(), fnPage, isOn, bubbleCount, clippingBadge };
  }
};
</script>

<style scoped></style>
